'use strict';

exports.__esModule = true;
var grants = exports.grants = ['create_company', 'edit_company', 'delete_company', 'read_companies'];

exports.default = grants;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmw-shell/lib/grants.js
// module id = 710
// module chunks = 49